module.exports = __webpack_public_path__ + "static/img/product1.1f9cdcb0.jpg";